import Page from '../../components/Page';

export default function Home() {
  return (
    <Page title="Home | Tecnozap">
      {/* <div>
        <h1>Bem vindo, meu usuário!</h1>
        <br />
        <p>Esta é a nova versão do Tecnozap 2.0!</p>
      </div> */}
    </Page>
  );
}
